// ============================================================
// Datei: src/pages/deployment/DeploymentDesktop.jsx
//
// ÄNDERUNGEN:
// - ShiftOverview wurde nicht direkt verändert
// - neue 3er-Tab-Komponente unter BadgeInfo eingefügt
// - Festival bleibt Standardansicht
// - bestehende Join-/Unenroll-Logik bleibt unverändert
// ============================================================

import React from "react";
import SalaryInfo from "../../components/SalaryInfo";
import BadgeInfo from "../../components/BadgeInfo";
import AssignedShifts from "../../components/AssignedShifts";
import DeploymentShiftTabs from "../../components/deploymentShiftTabs/DeploymentShiftTabs";

const DeploymentDesktop = ({
	shifts,
	assignedShifts,
	salaryInfo,
	badgeInfo,
	isJoining,
	showConfirm,
	handleJoinShift,
	confirmJoinShift,
	setShowConfirm,
	leaveShift
}) => {

	return (
		<div className="deployment-container bg-reveal">
			<h2 className="deployment-heading">Willkomme zu dinere Übersicht!</h2>

			<div className="assignment-salary-wrapper">
				<AssignedShifts
					shifts={assignedShifts}
					onLeaveShift={leaveShift}
				/>

				<SalaryInfo salary={salaryInfo} />

				<BadgeInfo badges={badgeInfo} />
			</div>

			{/* ============================================================
			    NEU:
			    Unterhalb von BadgeInfo gibt es jetzt die drei Tabs:
			    Aufbau, Festival, Abbau.

			    Wichtig:
			    - Festival ist die bisherige ShiftOverview.
			    - Aufbau und Abbau verwenden einen Zeitstrang.
			    - Die bestehende Einschreibelogik wird nur weitergereicht.
			   ============================================================ */}
			<DeploymentShiftTabs
				shifts={shifts}
				assignedShifts={assignedShifts}
				handleJoinShift={handleJoinShift}
				isMobile={false}
			/>

			{showConfirm && (
				<div className="confirm-overlay">
					<div className="confirm-box">
						<h3>Schicht übernehmen?</h3>

						<div className="confirm-buttons">
							<button
								className="confirm-yes"
								disabled={isJoining}
								onClick={confirmJoinShift}
							>
								{isJoining ? "..." : "Ja, einschreiben"}
							</button>

							<button
								className="confirm-no"
								onClick={() => setShowConfirm(false)}
							>
								Abbrechen
							</button>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default DeploymentDesktop;